module.exports = "/_next/static/images/8a028c07a2059b08134e7048ae5972db-website-thumb-large.jpg";